import { render, staticRenderFns } from "./CalendarV2.vue?vue&type=template&id=c53082a6&scoped=true&lang=html&"
import script from "./CalendarV2.vue?vue&type=script&lang=js&"
export * from "./CalendarV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c53082a6",
  null
  
)

export default component.exports